export default "__VITE_ASSET__DTVrWacm__"